export function getKey<T, M extends Record<string | number, T>>(
  map: M,
  value: T
): keyof M | undefined {
  return Object.keys(map).find((key) => map[key] === value)
}
